module.exports = __webpack_public_path__ + "img/logo.d3fa15bf.jpg";